(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    var openModal = null;
var lastFocused = null;
var scrollY = 0;

function isliFocusables(root) {
  return Array.prototype.filter.call(
    root.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])'),
    function (el) { return el.offsetParent !== null; }
  );
}

function isliOpen(modal) {
  var id = modal.getAttribute('data-isli-size-guide-modal');

  // Drop any stale copy left behind by a theme-editor re-render.
  var existing = document.querySelectorAll('[data-isli-size-guide-modal="' + id + '"]');
  Array.prototype.forEach.call(existing, function (node) {
    if (node !== modal && node.parentNode === document.body) {
      node.parentNode.removeChild(node);
    }
  });

  // Move to body so no ancestor overflow or transform can clip it.
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  lastFocused = document.activeElement;
  scrollY = window.scrollY;
  modal.hidden = false;
  openModal = modal;

  document.body.style.position = 'fixed';
  document.body.style.top = '-' + scrollY + 'px';
  document.body.style.width = '100%';

  var f = isliFocusables(modal);
  if (f.length) f[0].focus();
}

function isliClose() {
  if (!openModal) return;
  openModal.hidden = true;
  openModal = null;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);

  if (lastFocused && lastFocused.focus) lastFocused.focus();
}

document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-isli-size-guide-open]');
  if (opener) {
    var id = opener.getAttribute('data-isli-size-guide-open');
    var modal = document.querySelector('[data-isli-size-guide-modal="' + id + '"]');
    if (modal) {
      e.preventDefault();
      isliOpen(modal);
    }
    return;
  }
  if (openModal && e.target.closest('[data-isli-size-guide-close]')) {
    isliClose();
  }
});

document.addEventListener('keydown', function (e) {
  if (!openModal) return;

  if (e.key === 'Escape') {
    e.preventDefault();
    isliClose();
    return;
  }

  if (e.key !== 'Tab') return;
  var f = isliFocusables(openModal);
  if (!f.length) return;
  var first = f[0];
  var last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
});
  } catch(e) { console.error(e); }
})();

})();
